import { useContext } from 'react'
import Crear from '@/App/Panel/Ver/Crear';
import { PageContext } from '../PageContext';
export default function CrearPanel() {
    const { page } = useContext(PageContext)
    return <Crear props={{ page }} />
} 